import { CurrentApplicationUser } from "../apiModels/currentApplicationUser";
import apiPaths from "./apiPaths";
import { get, post } from "./apiUtilities";

export const getCurrentApplicationUser = async () => await get<CurrentApplicationUser>(apiPaths.getCurrentApplicationUser);

export const logout = async () => await post(apiPaths.logout);